var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('el-carousel',{attrs:{"trigger":"click","height":"400px","interval":3000,"arrow":"always"}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"img",attrs:{"src":item.img,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }